<template>
	<v-container>
	  <v-row justify="center">
	  	<v-col cols="12">
	  		<v-card class="shadowCard mt-16">
	  			
	  			<v-card-title primary-title>
	  				<v-spacer></v-spacer>
	  			  <span class="text-body-1 text-center">Examen del Exci</span>
	  				<v-spacer></v-spacer>
	  			</v-card-title>

	  		  <v-card-actions>
	  		    <v-img src="https://fastenglish.com.mx/public/images/infoexci.jpg" contain></v-img>
	  		  </v-card-actions>
	  		  <v-card-actions>
	  		    <v-btn color="primary"  block class="shadowCard" @click="exiparams.estatus = true">Registrarme</v-btn>
	  		    <!-- <v-spacer></v-spacer> -->
	  		    <!-- <v-btn color="secondary" class="shadowCard">Presentar</v-btn> -->
	  		  </v-card-actions>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <Registrar   v-if="exiparams.estatus" :exiparams="exiparams"  @click="agregarRegistro()"/>
	  <Alerta      v-if="respuestaAlerta"   :parametros="parametros"/>
	  <Loader      v-if="cargar"            :loader="loader"/>
	</v-container>
</template>

<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  import Registrar     from '@/views/exci/Registrar.vue'

	export default {
	  name: "dashboard-default",
	  data: () => ({
	  	url: '',

	    loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},
     	respuestaAlerta: false,

     	exiparams:{
     		estatus: false,
     		nombre:'',
				telefono:'',
				correo:'',
				sucursal:'',
				horario:'',
				codigo:'',
				apellidos:'',
     	}
	  }),

	  components: {
	    Alerta,
	    Loader,
	    Registrar
	  },

	  created(){

	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirRecursosAlumno', 'abrirVentanaRecurso'] ),

	  	validarErrores ( value ){
	  		this.cargar = false
  			if( value.status == 400 || value.status == 500 ){
    			this.parametros.mensaje = value.body.message
  				this.parametros.color        = '#FF2C2C'
    			this.parametros.dialogError  = true 
    			this.respuestaAlerta = true 
    		}
	  	},

	  	agregarRegistro( ){
	  		this.exiparams.estatus = false
	  		this.exiparams.nombre  = this.exiparams.nombre + ' ' + this.exiparams.apellidos
	  		this.cargar = true

	  		this.$http.post('exci.registro', this.exiparams).then( response=> {
	  			this.cargar = false
	  			this.parametros.mensaje = response.body.message
  				this.parametros.color        = 'success'
    			this.parametros.dialogError  = true 
    			this.respuestaAlerta = true 
	  		}).catch( error => {
	  		 this.validarErrores ( error )
	  			this.cargar = false
	  		}).finally( () => { this.cargar = false })
	  	}
	  }
	};
</script>
